/* eslint-disable no-restricted-syntax */

// import { FORM_KEYS } from 'shared/constant';
import { ACTION_TYPE } from './actionTypes';

const { PERSONAL_INFORMATION } = ACTION_TYPE;
// const { PEP } = FORM_KEYS;

const removeNullInObj = (obj) => {
  for (const propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
};

/** Patch data coming from the backend */
const fetchPersonalInformation = obj => (dispatch, getState) => {
  const {
    clientDetails, pep, bankDetails, sourceOfWealth, asi, clientProfileForm,
  } = getState().applicantRootReducer.personalInformationReducer;

  dispatch({
    type: PERSONAL_INFORMATION.FETCH_PERSONAL_INFORMATION,
    payload: {
      clientDetails: Object.assign(clientDetails, removeNullInObj(obj.clientDetails)),
      pep: Object.assign(pep, removeNullInObj(obj.pep)),
      bankDetails: Object.assign(bankDetails, removeNullInObj(obj.bankDetails)),
      sourceOfWealth: Object.assign(sourceOfWealth, removeNullInObj(obj.sourceOfWealth)),
      asi: Object.assign(asi, removeNullInObj(obj.asi)),
      clientProfileForm: Object.assign(clientProfileForm, removeNullInObj(obj.clientProfileForm)),
    },
  });
};

// const fetchPersonalInformation = obj => ({
//   type: PERSONAL_INFORMATION.FETCH_PERSONAL_INFORMATION,
//   payload: {
//     clientDetails: obj.clientDetails,
//     pep: obj.pep,
//     bankDetails: obj.bankDetails,
//     sourceOfWealth: obj.sourceOfWealth,
//     asi: obj.asi,
//     clientProfileForm: obj.clientProfileForm,
//   },
// });

/** Update Client details */
const updateClientDetails = (name, value) => ({
  type: PERSONAL_INFORMATION.UPDATE_CLIENT_DATA,
  payload: { name, value },
});

const updateQualifiedInvestorOptions = selectedId => (dispatch, getState) => {
  const { qualifiedInvestorOptions } = getState().applicantRootReducer.personalInformationReducer.clientDetails;
  let arrOfSelectedOptions;
  if (qualifiedInvestorOptions.includes(selectedId)) {
    arrOfSelectedOptions = qualifiedInvestorOptions.filter(item => item !== selectedId);
  } else {
    arrOfSelectedOptions = [...qualifiedInvestorOptions.filter(item => item !== selectedId), selectedId];
  }
  dispatch({
    type: PERSONAL_INFORMATION.CD_QUALIFIED_INVESTOR_OPTIONS,
    payload: arrOfSelectedOptions,
  });
};

/** Save array of investment strategies */
const updateInvestmentStrategies = selectedId => (dispatch, getState) => {
  const { investmentStrategies } = getState().applicantRootReducer.personalInformationReducer.clientDetails;
  let arrOfSelectedOptions;
  if (investmentStrategies.includes(selectedId)) {
    arrOfSelectedOptions = investmentStrategies.filter(item => item !== selectedId);
  } else {
    arrOfSelectedOptions = [...investmentStrategies.filter(item => item !== selectedId), selectedId];
  }
  dispatch({
    type: PERSONAL_INFORMATION.CD_INVESTMENT_STRATEGIES,
    payload: arrOfSelectedOptions,
  });
};

/** Update is beneficiaries a Pep  */
const updateIsPep = payload => ({
  type: PERSONAL_INFORMATION.IS_PEP,
  payload,
});

const pepBeneficiaries = payload => ({
  type: PERSONAL_INFORMATION.PEP_BENEFICIARIES,
  payload,
});

/** Add more PEP (array of object) */
const addMorePep = () => (dispatch, getState) => {
  const {
    pep: { list },
  } = getState().applicantRootReducer.personalInformationReducer;

  const newPep = {
    id: `pep-${list.length + 1}`,
    name: '',
    currentFormerOption: '',
    position: '',
    otherPosition: '',
    relationship: '',
  };

  const combinedPep = [...list, newPep];
  dispatch(pepBeneficiaries(combinedPep));
};

/**
 * Update pep list
 * @param {*} index
 * @param {*} key
 * @param {*} value
 * @return updated array of Pep List
 */
const updatePep = (index, key, value) => (dispatch, getState) => {
  const {
    pep: { list },
  } = getState().applicantRootReducer.personalInformationReducer;

  const objIndex = list.findIndex((x, i) => i === index);
  const newArr = [...list];
  newArr[objIndex] = { ...newArr[objIndex], [key]: value };

  dispatch(pepBeneficiaries(newArr));
};

/** remove PEP selected object */
const removePep = index => (dispatch, getState) => {
  const {
    pep: { list },
  } = getState().applicantRootReducer.personalInformationReducer;
  const filteredArr = list.filter(x => x.id !== index);
  dispatch(pepBeneficiaries(filteredArr));
};


/** Update Bank Details */
const updateBankDetails = (name, value) => ({
  type: PERSONAL_INFORMATION.UPDATE_BANK_DETAILS,
  payload: { name, value },
});

const updateLastFourDigits = (index, last4Digits, digitErr) => (dispatch, getState) => {
  const { bankDetails } = getState().applicantRootReducer.personalInformationReducer;

  const { cardInfo } = bankDetails;

  const modifiedCardInfo = cardInfo.map((card, idx) => (idx === index
    ? {
      ...card,
      lastFourDigits: last4Digits,
      digitErr,
    }
    : card));

  dispatch({
    type: PERSONAL_INFORMATION.UPDATE_CARD_INFO,
    payload: modifiedCardInfo,
  });
};

const updateCardMoYr = (index, mo, yr, value, error) => (dispatch, getState) => {
  const { bankDetails } = getState().applicantRootReducer.personalInformationReducer;

  const { cardInfo } = bankDetails;

  const modifiedCardInfo = cardInfo.map((card, idx) => (idx === index
    ? {
      ...card,
      expMonth: mo,
      expYear: yr,
      value,
      error,
    }
    : card));

  dispatch({
    type: PERSONAL_INFORMATION.UPDATE_CARD_INFO,
    payload: modifiedCardInfo,
  });
};


/** Update Source of Wealth & Funds */
const updateSourceOfWealth = (name, value) => ({
  type: PERSONAL_INFORMATION.UPDATE_SOURCE_OF_WEALTH,
  payload: { name, value },
});

/** Update Authorized Signatory Information */
const updateAsi = (name, value) => ({
  type: PERSONAL_INFORMATION.UPDATE_ASI,
  payload: { name, value },
});

const saveIsPoa = payload => ({
  type: PERSONAL_INFORMATION.SAVE_ASI_POA,
  payload,
});

/** Update Client Profile Form */
const updateClientProfile = (name, value) => ({
  type: PERSONAL_INFORMATION.UPDATE_CLIENT_PROFILE,
  payload: { name, value },
});

/** Save asset classes market selection */
const updateAssetClasses = selectedId => (dispatch, getState) => {
  const { assetClasses } = getState().applicantRootReducer.personalInformationReducer.clientProfileForm;
  let arrOfSelectedOptions;
  if (assetClasses.includes(selectedId)) {
    arrOfSelectedOptions = assetClasses.filter(item => item !== selectedId);
  } else {
    arrOfSelectedOptions = [...assetClasses.filter(item => item !== selectedId), selectedId];
  }
  dispatch({
    type: PERSONAL_INFORMATION.UPDATE_CLIENT_PROFILE_ASSET_CLASSES,
    payload: arrOfSelectedOptions,
  });
};

/** Save multiple market selection */
const updateMarkets = selectedId => (dispatch, getState) => {
  const { markets } = getState().applicantRootReducer.personalInformationReducer.clientProfileForm;
  let arrOfSelectedOptions;
  if (markets.includes(selectedId)) {
    arrOfSelectedOptions = markets.filter(item => item !== selectedId);
  } else {
    arrOfSelectedOptions = [...markets.filter(item => item !== selectedId), selectedId];
  }
  dispatch({
    type: PERSONAL_INFORMATION.UPDATE_CLIENT_PROFILE_MARKETS,
    payload: arrOfSelectedOptions,
  });
};

const saveInsiderList = payload => ({
  type: PERSONAL_INFORMATION.UPDATE_INSIDER_STATUS_LIST,
  payload,
});

/** Add more INSIDER STATUS (array of object) */
const addMoreInsider = () => (dispatch, getState) => {
  const {
    clientProfileForm: { insiderStatusList },
  } = getState().applicantRootReducer.personalInformationReducer;

  const newList = {
    id: `insiderForm-${insiderStatusList.length + 1}`,
    insiderCompany: '',
    insiderPosition: '',
  };

  const combinedList = [...insiderStatusList, newList];
  dispatch(saveInsiderList(combinedList));
  // dispatch({
  //   type: PERSONAL_INFORMATION.UPDATE_INSIDER_STATUS_LIST,
  //   payload: combinedList,
  // });
};

const updateInsiderList = (index, key, value) => (dispatch, getState) => {
  const {
    clientProfileForm: { insiderStatusList },
  } = getState().applicantRootReducer.personalInformationReducer;

  const objIndex = insiderStatusList.findIndex((x, i) => i === index);
  const newArr = [...insiderStatusList];
  newArr[objIndex] = { ...newArr[objIndex], [key]: value };

  dispatch(saveInsiderList(newArr));
};

const removeInsiderItem = id => (dispatch, getState) => {
  const {
    clientProfileForm: { insiderStatusList },
  } = getState().applicantRootReducer.personalInformationReducer;
  const filteredArr = insiderStatusList.filter(x => x.id !== id);
  dispatch(saveInsiderList(filteredArr));
};

const autoUpdateInvestmentExpToNo = () => ({
  type: PERSONAL_INFORMATION.AUTO_UPDATE_CLIENT_PROFILE_INVESTMENT_EXP,
});

/** Export actions here */
const personalInformation = {
  fetchPersonalInformation,

  updateClientDetails,
  updateQualifiedInvestorOptions,
  updateInvestmentStrategies,

  updateIsPep,
  addMorePep,
  updatePep,
  removePep,

  updateBankDetails,
  updateLastFourDigits,
  updateCardMoYr,
  updateSourceOfWealth,
  updateAsi,
  saveIsPoa,

  updateClientProfile,
  updateAssetClasses,
  updateMarkets,

  addMoreInsider,
  updateInsiderList,
  removeInsiderItem,

  autoUpdateInvestmentExpToNo,
};

export default personalInformation;
